module.exports = __webpack_public_path__ + "media/images/gfx/load_run-58e8a02cbbcbe1328f61dd768cd0ba91.gif";